import { createApp } from 'vue';
import Antd from 'ant-design-vue';
/**
 * 
 * 부트스트랩 리팩토링 하면서 삭제해야 할 파일
 */
import 'bootstrap/dist/js/bootstrap.js';
import 'bootstrap/dist/css/bootstrap.css';
/**
 * 
 * 부트스트랩 리팩토링 하면서 삭제해야 할 파일 끝
 */

import Vue3ColorPicker from 'vue3-colorpicker';
import VueDatePicker from '@vuepic/vue-datepicker';

import App from './App.vue';
import store from './store';
import router from './router';
import apiInstance from './axios';
import i18n from './i18n'

import 'ant-design-vue/dist/reset.css';

import 'vue3-colorpicker/style.css';
import '@vuepic/vue-datepicker/dist/main.css'

import CssLoader from './css-loader';
/*
  모바일 화면(정품 라벨 등록)의 디자인 토큰.

  커스텀 프로퍼티 선언(--mk-*)뿐이라 선택자를 만들지 않는다 — 다른 화면의 모양을 바꾸지 않는다.
  scoped 안에서 읽으면 Vue 가 `[data-v-…]:root` 로 바꿔 정의가 무효가 되므로 여기서 한 번 읽는다.
  나머지 규칙은 각 컴포넌트가 scoped 안에서 mobile-kit.scss 를 읽는다.
*/
import './assets/scss/mobile-kit-tokens.scss';
import './assets/css/nucleo-icons.css';
import './assets/css/nucleo-svg.css';

if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    const isResizeObserverLoopError = (message) => (
        /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/.test(String(message || ''))
    );

    if (window.ResizeObserver) {
        const NativeResizeObserver = window.ResizeObserver;
        window.ResizeObserver = class DeferredResizeObserver extends NativeResizeObserver {
            constructor(callback) {
                let frameId = 0;
                super((entries, observer) => {
                    if (frameId) {
                        window.cancelAnimationFrame(frameId);
                    }
                    frameId = window.requestAnimationFrame(() => {
                        frameId = 0;
                        callback(entries, observer);
                    });
                });
            }
        };
    }

    window.addEventListener('error', (event) => {
        if (!isResizeObserverLoopError(event.message)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
    }, true);

    window.addEventListener('unhandledrejection', (event) => {
        if (!isResizeObserverLoopError(event.reason?.message || event.reason)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
    }, true);
}

const app = createApp(App);

app.component('VueDatePicker', VueDatePicker);

app.use(store);
app.use(router);
app.use(i18n);
app.use(Antd)
app.use(Vue3ColorPicker)
app.use(CssLoader);
app.config.globalProperties.$apiInstance = apiInstance;
// store 액션도 토큰 재발행을 거치게 한다. store 에서 "@/axios" 를 import 하면 axios → store 순환이 생겨 여기서 꽂는다.
store.$apiInstance = apiInstance;

app.mount('#app');
